<template>
  <div class="wish-list-edit-limit-page__container">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError
          v-if="showableErrorFeedback"
          :message="feedbackErrorMessage"
        />
      </transition>
    </div>
    <div class="wish-list-edit-limit-page__page-header-area">
      <PageHeadlineTitle title="受け取りたい個数設定" />
    </div>
    <div class="wish-list-edit-limit-page__main-area">
      <div class="wish-list-edit-limit-page__main-content">
        <div
          v-if="showBoxListAlert"
          class="wish-list-edit-limit-page__box-list-area"
        >
          <ul class="box-list--alert wish-list-edit-limit-page__box-list">
            <li v-if="hasQuantityError">
              受け取りたい個数は半角数字で0~999の間で入力してください
            </li>
            <li v-if="hasUserWishListError">
              お手数ですが画面を読み込み直して再度お試しください
            </li>
          </ul>
        </div>
        <ul class="wish-list-edit-limit-page__caption-ul">
          <li class="wish-list-edit-limit-page__caption-li">
            ギフトごとに受け取りたい個数を0~999の間で設定できます
          </li>
          <li class="wish-list-edit-limit-page__caption-li">
            設定した個数はほしいものリスト上に公開されます
          </li>
          <li class="wish-list-edit-limit-page__caption-li">
            ほしいものリスト経由で対象ギフトを受け取ると、設定した個数からマイナスされます
          </li>
          <li class="wish-list-edit-limit-page__caption-li">
            複数人が同時にギフトを贈った場合、設定した個数を超えて贈られることがあります
          </li>
          <li class="wish-list-edit-limit-page__caption-li">
            個数設定のチェックを外すと数値がリセットされます
          </li>
        </ul>
        <div class="wish-list-edit-limit-page__form-area">
          <SmallLoading
            v-if="isUserWishListsLoading"
            class="wish-list-edit-limit-page__loading"
          />
          <div v-else>
            <WishListItemForEditLimit
              v-for="userWishList in userWishLists"
              :key="userWishList.id"
              :user-wish-list-id="userWishList.id"
              :image-url="userWishList.imageUrl"
              :brand-name="userWishList.brandName"
              :item-name="userWishList.itemName"
              :item-sku-name="userWishList.itemSkuName"
              :item-id="userWishList.itemId"
              :item-sku-id="userWishList.itemSkuId"
              :is-use-setting-checked="userWishList.isUseSettingChecked"
              :is-sold-out="userWishList.isSoldOut"
              :wanted-quantity="userWishList.wantedQuantity"
              :has-quantity-error="userWishList.hasQuantityError"
              @click-use-setting-checkbox="
                toggleUseSettingCheckbox(userWishList.id)
              "
              @input-quantity="updateQuantity($event, userWishList.id)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wish-list-edit-limit-page__submit-area">
      <div class="wish-list-edit-limit-page__submit-buttons">
        <ButtonSecondary
          text="キャンセル"
          class="wish-list-edit-limit-page__cancel-button"
          :disabled="isSubmitButtonDisable || null"
          @click-secondary-button="clickCancelButton"
        />
        <ButtonPrimary
          text="変更を保存"
          class="wish-list-edit-limit-page__submit-button"
          :disabled="isSubmitButtonDisable || null"
          @click-primary-button="clickSubmitButton"
        />
      </div>
    </div>
    <TextModalWithSecondary
      v-if="showCancelDialog"
      title-text="変更内容が保存されていません"
      caption-text=""
      primary-button-text="編集を続ける"
      secondary-button-text="保存せずに前の画面に戻る"
      cancel-button-text="閉じる"
      @clicked-modal-cover="closeCancelModal"
      @clicked-primary="closeCancelModal"
      @clicked-secondary="backToWishListPage"
      @clicked-cancel="closeCancelModal"
    />
  </div>
</template>
<script>
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import PageHeadlineTitle from '../../../atoms/headlines/PageHeadlineTitle.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import WishListItemForEditLimit from '../../../molecules/wish_list/WishListItemForEditLimit.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary.vue'

import axios from 'axios'
import { cloneDeep, isEqual } from 'lodash'

export default {
  components: {
    FeedbackError,
    PageHeadlineTitle,
    SmallLoading,
    WishListItemForEditLimit,
    ButtonSecondary,
    ButtonPrimary,
    TextModalWithSecondary
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    screenName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableErrorFeedback: false,
      feedbackErrorMessage: '',
      isUserWishListsLoading: true,
      userWishLists: [],
      initialUserWishLists: [],
      hasQuantityError: false,
      hasUserWishListError: false,
      hasFrontValidationError: false,
      isSubmitButtonDisable: false,
      showCancelDialog: false
    }
  },
  computed: {
    showBoxListAlert() {
      return this.hasQuantityError || this.hasUserWishListError
    },
    changeAnyValue() {
      return !isEqual(this.initialUserWishLists, this.userWishLists)
    }
  },
  mounted() {
    this.getUserWishLists()
  },
  methods: {
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showError(error) {
      this.showableErrorFeedback = true
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
    },
    async getUserWishLists() {
      this.isUserWishListsLoading = true
      this.isSubmitButtonDisable = true
      try {
        const res = await axios.get(
          `/api/v1/wish_lists?screen_name=${this.screenName}`
        )
        this.userWishLists = res.data.data.map(wishListTicket => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = wishListTicket.attributes.item_sku_image_url
            ? wishListTicket.attributes.item_sku_image_url
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: wishListTicket.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: wishListTicket.attributes.item_sku_id,
            itemSkuName: wishListTicket.attributes.item_sku_name,
            itemId: wishListTicket.attributes.item_id,
            itemName: wishListTicket.attributes.item_name,
            brandName: wishListTicket.attributes.item_sku_brand_name,
            isUseSettingChecked: wishListTicket.attributes.has_limit,
            isSoldOut: wishListTicket.attributes.is_sold_out,
            wantedQuantity: this.calcWantedQuantity(
              wishListTicket.attributes.wanted_quantity,
              wishListTicket.attributes.received_quantity
            ),
            hasQuantityError: false
          }
        })

        this.initialUserWishLists = cloneDeep(this.userWishLists)
        this.isUserWishListsLoading = false
        this.isSubmitButtonDisable = false
      } catch (error) {
        this.isUserWishListsLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    calcWantedQuantity(wantedQuantity, receivedQuantity) {
      return wantedQuantity === null ? null : wantedQuantity - receivedQuantity
    },
    toggleUseSettingCheckbox(userWishListId) {
      this.userWishLists.forEach(userWishList => {
        if (userWishList.id === userWishListId) {
          userWishList.isUseSettingChecked = !userWishList.isUseSettingChecked
        }
      })
    },
    updateQuantity(inputValue, userWishListId) {
      this.userWishLists.forEach(userWishList => {
        if (userWishList.id === userWishListId) {
          const intValue = parseInt(inputValue)
          userWishList.wantedQuantity = isNaN(intValue) ? null : intValue
        }
      })
    },
    clickCancelButton() {
      this.isSubmitButtonDisable = true
      if (this.changeAnyValue) {
        this.showCancelDialog = true
      } else {
        this.backToWishListPage()
      }
    },
    backToWishListPage() {
      window.location = `/u/${this.screenName}`
    },
    closeCancelModal() {
      this.showCancelDialog = false
      this.isSubmitButtonDisable = false
    },
    async clickSubmitButton() {
      this.isSubmitButtonDisable = true

      this.validateBeforeSubmit()
      if (this.hasFrontValidationError) {
        this.isSubmitButtonDisable = false
        return
      }

      if (!this.isApp) {
        dataLayer.push({
          event: 'click_edit_limit__save'
        })
      } else {
        logEvent('click_edit_limit__save')
      }

      try {
        const res = await axios.post(`/api/v1/wish_lists/update_limit`, {
          user_wish_lists: this.userWishLists
        })
        if (res.data.saved) {
          window.location = `/u/${this.screenName}`
        } else {
          this.hasUserWishListError =
            res.data.validate_result.has_user_wish_list_error

          const wantedQuantityErrorUserWishListIds =
            res.data.validate_result.wanted_quantity_error_user_wish_list_ids
          if (wantedQuantityErrorUserWishListIds.length >= 1) {
            this.userWishLists.forEach(userWishList => {
              if (
                wantedQuantityErrorUserWishListIds.includes(userWishList.id)
              ) {
                userWishList.hasQuantityError = true
                this.hasQuantityError = true
              }
            })
          }

          window.scrollTo({ top, behavior: 'smooth' })
          this.showableErrorFeedback = true
          this.feedbackErrorMessage = 'エラーが発生しました'
          this.isSubmitButtonDisable = false
        }
      } catch (error) {
        this.isSubmitButtonDisable = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    validateBeforeSubmit() {
      this.hasFrontValidationError = false
      this.userWishLists.forEach(userWishList => {
        if (
          userWishList.isUseSettingChecked &&
          (userWishList.wantedQuantity === null ||
            userWishList.wantedQuantity < 0 ||
            userWishList.wantedQuantity > 999)
        ) {
          userWishList.hasQuantityError = true
          this.hasQuantityError = true
          this.hasFrontValidationError = true
        }
      })

      if (this.hasFrontValidationError) {
        window.scrollTo({ top, behavior: 'smooth' })
        this.showableErrorFeedback = true
        this.feedbackErrorMessage = 'エラーが発生しました'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-edit-limit-page {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__page-header-area {
    background: $white;
    height: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__main-area {
    background: $white;
    margin-top: 16px;
  }

  &__main-content {
    max-width: $small-contents-width;
    margin: auto;
    padding-top: 32px;
  }

  &__box-list-area {
    text-align: left;
    padding: 0 16px;
    margin-bottom: 24px;
  }

  &__box-list {
    padding: 16px;

    li {
      @extend %minimal;
      color: $danger;
    }
  }

  &__caption-ul {
    padding: 0 16px 24px 32px;

    li {
      @extend %caption;
      list-style: disc;
      text-align: left;
    }
  }

  &__loading {
    padding-bottom: 16px;
  }

  &__submit-area {
    background-color: $white;
    border-top: 1px solid $gray-2;
    position: sticky;
    bottom: 0;
  }

  &__submit-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    max-width: $small-contents-width;
    margin: auto;
    padding: 24px 16px;
  }

  &__cancel-button {
    border-color: $gray-1;
    color: $gray-1;
    width: 148px;
  }

  &__submit-button {
    width: 148px;
  }
}
</style>
